import { renderGraphSvg } from '@ipfabric/utils';
import type { GraphData } from 'components/Graph/model/GraphData';
import { identity, pipe } from 'fp-ts/lib/function';
import { exportGraphWithoutHiddenElements } from './exportGraphWithoutHiddenElements';

export const createGraphSvg = (
  graphData: GraphData,
  peekingAtHiddenNodes: boolean,
): string =>
  pipe(
    graphData,
    peekingAtHiddenNodes ? identity : exportGraphWithoutHiddenElements,
    renderGraphSvg,
  );
